import { useEffect, useState } from 'react'
import { FC, invalidateQuery, useCQuery } from '../../Services'

export const useEnvironment = (environmentId) => {
  const [environment, setEnvironment] = useState()
  const { data, isSuccess } = useCQuery(['environment', environmentId])

  useEffect(() => {
    isSuccess && setEnvironment(data)
  }, [isSuccess, data])

  const setEnvironmentProp = (prop, value) =>
    setEnvironment({ ...environment, [prop]: value })

  return [environment, setEnvironmentProp, isSuccess]
}

export const saveEnvironment = async (environment) => {
  if (!environment.name) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Inserire campi obbligatori' })
    return false
  }
  if (environment.id === 'new') {
    delete environment.id
    try {
      const res = await FC.service('environments').create({ ...environment })
      invalidateQuery(['environment', 'environments'])
      window.growl.show({ severity: 'success', summary: 'Success', detail: 'Salvataggio effettuato' })
      return res
    } catch (e) {
      window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore Salvataggio' })
      return false
    }
  }
  try {
    const res = await FC.service('environments').patch(environment.id, environment)
    invalidateQuery(['environment', 'environments'])
    window.growl.show({ severity: 'success', summary: 'Success', detail: 'Salvataggio effettuato' })
    return res
  } catch (e) {
    window.growl.show({ severity: 'error', summary: 'Errore', detail: 'Errore Salvataggio' })
    return false
  }
}

export const deleteEnvironment = async (environmentId) => {
  const res = await FC.service('environments').remove(environmentId)
  invalidateQuery(['environment', 'environments'])
  window.growl.show({ severity: 'success', summary: 'Success', detail: 'Eliminazione effettuata' })
  return res
}
